import { render } from "./RealTimeSalesChart.vue?vue&type=template&id=31d2b346&ts=true"
import script from "./RealTimeSalesChart.vue?vue&type=script&lang=ts"
export * from "./RealTimeSalesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__